import React, { createContext, useContext, useEffect, useState } from 'react';
import langData from '../langs/lang.json';

const LanguageContext = createContext();
const STORAGE_KEY = 'thepulse_language';
const DEFAULT_LANGUAGE = 'en';

// Exportado para el aviso de error (ErrorBoundary), que no puede depender del contexto
export const getInitialLanguage = () => {
  const savedLanguage = localStorage.getItem(STORAGE_KEY);
  if (savedLanguage && langData[savedLanguage]) {
    return savedLanguage;
  }

  const browserLanguage = navigator.language?.slice(0, 2);
  if (browserLanguage && langData[browserLanguage]) {
    return browserLanguage;
  }

  return DEFAULT_LANGUAGE;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(getInitialLanguage);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, language);
    document.documentElement.lang = language;
  }, [language]);

  const changeLanguage = (nextLanguage) => {
    if (langData[nextLanguage]) {
      setLanguage(nextLanguage);
    }
  };

  const t = (key) => {
    return langData[language]?.[key] || langData[DEFAULT_LANGUAGE]?.[key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage: changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
